/* unplugin-vue-components disabled */import { render } from "./childExhibitionItem.vue?vue&type=template&id=1e9dca18&scoped=true"
import script from "./childExhibitionItem.vue?vue&type=script&lang=js"
export * from "./childExhibitionItem.vue?vue&type=script&lang=js"

import "./childExhibitionItem.vue?vue&type=style&index=0&id=1e9dca18&scoped=true&lang=scss"
import "./childExhibitionItem.vue?vue&type=style&index=1&id=1e9dca18&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9dca18"]])

export default __exports__